import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const toPay = async (params: object) => {
  return await POST({
    url: Api.toPay,
    params: {
      ...params
    },
    showError: false
  })
}
